import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import io from "socket.io-client";
import moment from "moment";
var MaintenanceMode = {
  install: function install(Vue) {
    var state = Vue.observable({
      isMaintenanceMode: false,
      expirationTime: null,
      startTime: null,
      scheduledMaintenance: [],
      archivedMaintenance: [],
      userGroups: [],
      scheduledMaintenanceId: null,
      scheduledMaintenanceAssociated: null,
      errorMaintenance: "toto"
    });
    var socketServerUrl = process.env.VUE_APP_SOCKET_SERVER_URL;
    var isDevEnvironment = process.env.NODE_ENV === "development";
    var socket = io(socketServerUrl, {
      withCredentials: true,
      transports: ["websocket"],
      reconnection: !isDevEnvironment
    });
    var maintenanceMode = {
      get isActive() {
        return state.isMaintenanceMode;
      },
      get expirationTime() {
        return state.expirationTime;
      },
      get startTime() {
        return state.startTime;
      },
      get scheduledMaintenanceId() {
        return state.scheduledMaintenanceId;
      },
      get scheduledMaintenance() {
        return state.scheduledMaintenance;
      },
      get archivedMaintenance() {
        return state.archivedMaintenance;
      },
      get userGroups() {
        return state.userGroups;
      },
      get scheduledMaintenanceAssociated() {
        return state.scheduledMaintenanceAssociated;
      },
      get errorMaintenance() {
        return state.errorMaintenance;
      },
      getUpcomingMaintenance: function getUpcomingMaintenance() {
        var now = moment.utc();
        var upcomingMaintenance = state.scheduledMaintenance.find(function (maintenance) {
          var start = moment.utc(maintenance.start_time);
          var timeDiff = start.diff(now, "minutes");
          var alertThresholdMinutes = maintenance.alert_threshold_minutes || 60;
          return Math.abs(timeDiff) <= alertThresholdMinutes;
        });
        if (upcomingMaintenance) {
          return _objectSpread(_objectSpread({}, upcomingMaintenance), {}, {
            timeUntilStart: moment.utc(upcomingMaintenance.start_time).diff(now, "minutes")
          });
        }
        return null;
      },
      set: function set(value, expirationTime) {
        var startTime = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : moment.utc();
        var scheduledMaintenanceId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
        state.isMaintenanceMode = value;
        state.expirationTime = expirationTime;
        state.startTime = startTime;
        state.scheduledMaintenanceId = scheduledMaintenanceId;
        socket.emit("setMaintenanceMode", {
          isMaintenanceMode: value,
          startTime: state.startTime,
          expirationTime: expirationTime,
          scheduledMaintenanceId: scheduledMaintenanceId
        });
      },
      activate: function activate(expirationTime, startTime) {
        var scheduledMaintenanceId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        this.set(true, expirationTime, startTime, scheduledMaintenanceId);
      },
      deactivate: function deactivate() {
        this.set(false, null, null, null);
      },
      toggle: function toggle(expirationTime) {
        var scheduledMaintenanceId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        this.set(!state.isMaintenanceMode, state.isMaintenanceMode ? null : expirationTime, moment.utc(), scheduledMaintenanceId);
      },
      fetchScheduledMaintenance: function fetchScheduledMaintenance() {
        socket.emit("getScheduledMaintenance");
      },
      fetchArchivedMaintenance: function fetchArchivedMaintenance() {
        socket.emit("getArchivedMaintenance");
      },
      addScheduledMaintenance: function addScheduledMaintenance(startTime, endTime, description, alertThresholdMinutes) {
        var targetGroups = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
        socket.emit("setScheduledMaintenance", {
          startTime: startTime,
          endTime: endTime,
          description: description,
          alertThresholdMinutes: alertThresholdMinutes,
          targetGroups: targetGroups
        });
      },
      updateScheduledMaintenance: function updateScheduledMaintenance(id, startTime, endTime, description) {
        socket.emit("updateScheduledMaintenance", {
          id: id,
          startTime: startTime,
          endTime: endTime,
          description: description
        });
      },
      deleteScheduledMaintenance: function deleteScheduledMaintenance(id) {
        socket.emit("deleteScheduledMaintenance", {
          id: id
        });
      },
      archiveScheduledMaintenance: function archiveScheduledMaintenance(id) {
        socket.emit("archiveScheduledMaintenance", {
          id: id
        });
      },
      fetchUserGroups: function fetchUserGroups() {
        socket.emit("getUserGroups");
      }
    };
    Vue.prototype.$maintenanceMode = maintenanceMode;
    Vue.mixin({
      computed: {
        $isMaintenanceMode: {
          get: function get() {
            return state.isMaintenanceMode;
          },
          set: function set(value) {
            maintenanceMode.set(value, state.expirationTime, state.startTime, state.scheduledMaintenanceId);
          },
          $upcomingMaintenance: function $upcomingMaintenance() {
            return maintenanceMode.getUpcomingMaintenance();
          }
        },
        $maintenanceExpirationTime: {
          get: function get() {
            return state.expirationTime;
          },
          set: function set(value) {
            maintenanceMode.set(state.isMaintenanceMode, value, state.startTime, state.scheduledMaintenanceId);
          }
        },
        $maintenanceStartTime: {
          get: function get() {
            return state.startTime;
          }
        },
        $scheduledMaintenance: {
          get: function get() {
            return state.scheduledMaintenance;
          }
        },
        $archivedMaintenance: {
          get: function get() {
            return state.archivedMaintenance;
          }
        },
        $maintenanceUserGroups: {
          get: function get() {
            return state.userGroups;
          }
        }
      }
    });
    socket.on("maintenanceModeChanged", function (_ref) {
      var isMaintenanceMode = _ref.isMaintenanceMode,
        expirationTime = _ref.expirationTime,
        startTime = _ref.startTime,
        scheduledMaintenanceId = _ref.scheduledMaintenanceId,
        scheduledMaintenanceAssociated = _ref.scheduledMaintenanceAssociated;
      state.isMaintenanceMode = isMaintenanceMode;
      state.expirationTime = expirationTime;
      state.startTime = startTime;
      state.scheduledMaintenanceId = scheduledMaintenanceId || null;
      state.scheduledMaintenanceAssociated = scheduledMaintenanceAssociated;
    });
    socket.on("scheduledMaintenanceUpdated", function (scheduledMaintenance) {
      state.scheduledMaintenance = scheduledMaintenance;
    });
    socket.on("archivedMaintenanceUpdated", function (archivedMaintenance) {
      state.archivedMaintenance = archivedMaintenance;
    });
    socket.on("userGroupsFetched", function (userGroups) {
      state.userGroups = userGroups;
    });
    socket.on("connect_error", function (error) {
      console.error("Socket connection error:", error);
    });
    socket.on("errorMaintenance", function (error) {
      console.error("Error maintenance:", error);
      state.errorMaintenance = error;
    });
  }
};
export default MaintenanceMode;